{
  "name": "festival_scope_pro_front",
  "version": "5.31.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "local": "ng serve --proxy-config proxy-local.config.json --ssl true --ssl-cert ./ssl/localhost.pem --ssl-key ./ssl/localhost-key.pem --port 4200",
    "fake-local": "ng serve --proxy-config proxy-local.config.json --ssl true --ssl-cert ./ssl/fakestivalscope.com.pem --ssl-key ./ssl/fakestivalscope.com-key.pem --host fakestivalscope.com",
    "dev": "ng serve --proxy-config proxy-dev.config.json",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.5",
    "@angular/cdk": "^19.2.8",
    "@angular/common": "^19.2.5",
    "@angular/compiler": "^19.2.5",
    "@angular/core": "^19.2.5",
    "@angular/forms": "^19.2.5",
    "@angular/material": "^19.2.8",
    "@angular/material-moment-adapter": "^19.2.8",
    "@angular/platform-browser": "^19.2.5",
    "@angular/platform-browser-dynamic": "^19.2.5",
    "@angular/router": "^19.2.5",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-svg-core": "^1.2.36",
    "@fortawesome/free-solid-svg-icons": "^5.15.4",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@sentry/angular": "^10.17.0",
    "@stripe/stripe-js": "^1.38.1",
    "@types/stripe-v3": "^3.1.27",
    "compression": "^1.7.4",
    "express": "^4.21.2",
    "lucide-angular": "^0.503.0",
    "marked": "^15.0.7",
    "moment": "^2.29.4",
    "ng-recaptcha-2": "^15.0.0",
    "ngx-cookie-service": "^19.0.0",
    "ngx-cookieconsent": "^8.0.0",
    "ngx-custom-material-file-input": "^19.0.0",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-markdown": "^19.1.1",
    "ngx-scrollbar": "^10.0.1",
    "ngx-skeleton-loader": "^6.0.0",
    "rxjs": "~7.4.0",
    "stripe-angular": "^1.7.0",
    "swiper": "^8.4.7",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.0",
    "@angular/cli": "^19.2.0",
    "@angular/compiler-cli": "^19.2.0",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^12.11.1",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "5.8.2"
  }
}
